import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createBlock(_component_el_select, {
    disabled: $props.disabled,
    multiple: $props.multiple,
    modelValue: $setup.selectedValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.selectedValue = $event),
    filterable: "",
    remote: "",
    "reserve-keyword": "",
    placeholder: $props.placeholder,
    "remote-method": $setup.remoteMethod,
    loading: $setup.loading,
    onChange: $setup.handleChange,
    clearable: ""
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.options, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item[$props.valuekey],
        label: item[$props.labelkey],
        value: item[$props.valuekey]
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["disabled", "multiple", "modelValue", "placeholder", "remote-method", "loading", "onChange"]);
}